var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_32750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5886 14.5829L17.0971 0.434286C16.8457 0.16 16.48 0 16.0914 0C15.7029 0 15.36 0.16 15.0857 0.434286L0.411429 14.5829C0.16 14.8343 0.0228571 15.1771 0 15.5429V30.4457C0 31.2 0.617143 31.84 1.39429 31.84H11.9543C12.7086 31.84 13.3486 31.2229 13.3486 30.4457V19.3829H18.88V30.4457C18.88 31.2 19.4971 31.84 20.2743 31.84H30.6057C30.9714 31.84 31.3371 31.7029 31.5886 31.4286C31.84 31.1771 32 30.8114 32 30.4457V15.5657C32 15.2 31.8629 14.8571 31.5886 14.6057V14.5829Z",
    fill: "#575757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_32750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f28d44ad3342606c02036bd208be8164.svg";
export { ForwardRef as ReactComponent };